module.exports = __webpack_public_path__ + "static/images/element-icons_732389de.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.15.13@element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 218
// module chunks = 1